/**
 * Create / edit **request** flow: sidebar steps and URL `?step=` params — not a generic multi-step router abstraction.
 *
 * Legacy combined site step: older builds used one step id for site walk + dimensions together.
 * Deep links with `?step=site-dimensions` or legacy `site-walk` map to **`opportunity`**.
 */
export const LEGACY_COMBINED_SITE_STEP_ID = 'site-dimensions' as const;

export function normalizeRequestFormStepId(stepId: string): string {
  if (stepId === LEGACY_COMBINED_SITE_STEP_ID || stepId === 'site-walk') {
    return 'opportunity';
  }
  /** Legacy standalone step id; requestor fields live on the Opportunity step. */
  if (stepId === 'requestor') {
    return 'opportunity';
  }
  if (stepId === 'racks') {
    return 'rack-power';
  }
  if (stepId === 'customer-it') {
    return 'monitoring';
  }
  /** Legacy standalone step id; SFN fields live on the Liquid Cooling step. */
  if (stepId === 'secondary-fluid-network') {
    return 'liquid-cooling';
  }
  /** Legacy wizard step; feedback step removed from create/detail tail — deep links open Summary. */
  if (stepId === 'feedback') {
    return 'summary';
  }
  return stepId;
}
